import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useChartData } from '../../context/ChartContext';
import { formatNumber } from '../../utility/formatNumber';
const styles = {
    text: {
        fontSize: '11px',
        textAnchor: 'middle',
        dominantBaseline: 'middle',
        writingMode: 'vertical-rl',
        fill: 'black',
    },
    path: {
        fill: 'none',
        strokeWidth: '1px',
        shapeRendering: 'crispEdges',
        stroke: 'black',
    },
};
export function IntegralIndicator(props) {
    const { value, width, format, opacity = 1 } = props;
    const { height, margin } = useChartData();
    const bottom = height - margin.bottom;
    return (_jsxs("g", { style: { transform: `translate(0,${bottom - 10}px) `, opacity }, children: [_jsx("text", { style: {
                    ...styles.text,
                    transform: `translate(${width / 2}px,-12px) scale(-1)`,
                }, children: value ? formatNumber(value, format) : '' }), _jsx("path", { style: styles.path, d: `M0 0 L0 5 L${width} 5 L${width} 0 ` })] }));
}
